<template>
  <div>
      <div class="bodyWrap">
            <header>
              <div class="headTop">
                  <div class="topBox">
                       <div class="headLeft fl">
                        <span>时间：2021年3月31日</span>
                        <span>星期三</span>
                      </div>
                      <div class="headRig fr">
                  <router-link  to="/login" tag="span">登录</router-link>
                           <router-link to="/register" tag="span">注册</router-link>
                      </div>
                  </div>
              </div>
              <div class="headBottom">
                 <div class="bottomBox">
                    <div class="botLeft fl">
                    <img src="../../assets/img/show/logo.png" alt="">
                  </div>
                  <div class="botdRig fr">
                    <ul class="fl headUl">
                      <li>资源管理</li>
                      <li>统计分析</li>
                      <li>返回信息网</li>
                    </ul>
                    <div class="fr headSearch">
                          <el-input v-model="input" placeholder="发现数据从这里开始"></el-input>
                          <span>
                              <img src="../../assets/img/show/search.png" alt="">
                          </span>
                    </div>
                  </div>
                 </div>
              </div>
          </header>
          <div class="main">     
            <div class="tabZujian">
              <div class="navBox">
                <ul>
                  <li @click="cur=0" :class="{active2:cur==0}">我的资源</li>
                  <li @click="cur=1" :class="{active2:cur==1}">我的消息</li>
                   <li @click="cur=2" :class="{active2:cur==3}">个人设置</li>
              </ul>
              </div>
              <div class="tabContent">
                  <div v-show="cur==0">
                    <div class="title">
                        <p>当前位置：个人中心 > 关联资源</p>
                    </div>
                    <div class="content1">
                        <div class="contentLeft">
                            <dl>
                              <dt>
                                <img src="../../assets/img/show/person.png" alt="">
                              </dt>
                              <dd>
                                <p>昵称：<span>abcd</span></p>
                                <p>姓名：<span>张三</span><a>已认证</a>        
                                <p>联系方式：<span>11111111111</span></p>
                                <p>所在地区：<span>海南-海口</span></p>
                                <p>单位名称：<span>兴隆热带植物园</span></p>
                                 <a href="##">编辑</a>
                                </dd>
                            </dl>
                            <ul class="myZy">
                              <li class="myZyHigh">
                                 <span></span>
                                 我收藏的资源（112）
                              </li>
                              <li><span></span>我申请的资源（22）</li>
                              <li><span></span>我发布的资源（22）</li>
                              <li><span></span>发布资源</li>
                            </ul>
                            <div class="ewm">
                              <img src="../../assets/img/show/ewm.png" alt="">
                            </div>
                        </div>
                         <div class="rigBox fr">
                            <div class="rigBox1">
                                  <el-input v-model="input" placeholder="请输入您要检索的数据资源"></el-input>
                                  <div class="searchBtn">
                                    <button>搜 索</button>
                                  </div>
                             </div>
                            <div class="rigBox2">
                               <h2>共 <span>112</span> 条资源</h2>
                               <ul class="perUl">
                                  <li>
                                     <div class="perFirst">
                                         <strong>RO/JP/3 22/52s</strong>
                                     </div>
                                     <div class="perLast">
                                       <p>该种质资源为大戟科（Euphobiaceae）橡胶树属，来源巴西亚马逊河，资源种质类型属于野生资源。</p>
                                     </div>
                                  </li>
                              <li>
                                     <div class="perFirst">
                                         <strong>RO/JP/3 22/52s</strong>
                                     </div>
                                     <div class="perLast">
                                       <p>该种质资源为大戟科（Euphobiaceae）橡胶树属，来源巴西亚马逊河，资源种质类型属于野生资源。</p>
                                     </div>
                                  </li>
                                  <li>
                                     <div class="perFirst">
                                         <strong>RO/JP/3 22/52s</strong>
                                     </div>
                                     <div class="perLast">
                                       <p>该种质资源为大戟科（Euphobiaceae）橡胶树属，来源巴西亚马逊河，资源种质类型属于野生资源。</p>
                                     </div>
                                  </li>
                                  <li>
                                     <div class="perFirst">
                                         <strong>RO/JP/3 22/52s</strong>
                                     </div>
                                     <div class="perLast">
                                       <p>该种质资源为大戟科（Euphobiaceae）橡胶树属，来源巴西亚马逊河，资源种质类型属于野生资源。</p>
                                     </div>
                                  </li>
                                  <li>
                                     <div class="perFirst">
                                         <strong>RO/JP/3 22/52s</strong>
                                     </div>
                                     <div class="perLast">
                                       <p>该种质资源为大戟科（Euphobiaceae）橡胶树属，来源巴西亚马逊河，资源种质类型属于野生资源。</p>
                                     </div>
                                  </li>
                                  <li>
                                     <div class="perFirst">
                                         <strong>RO/JP/3 22/52s</strong>
                                     </div>
                                     <div class="perLast">
                                       <p>该种质资源为大戟科（Euphobiaceae）橡胶树属，来源巴西亚马逊河，资源种质类型属于野生资源。</p>
                                     </div>
                                  </li>
                                  <li>
                                     <div class="perFirst">
                                         <strong>RO/JP/3 22/52s</strong>
                                     </div>
                                     <div class="perLast">
                                       <p>该种质资源为大戟科（Euphobiaceae）橡胶树属，来源巴西亚马逊河，资源种质类型属于野生资源。</p>
                                     </div>
                                  </li>
                                  <li>
                                     <div class="perFirst">
                                         <strong>RO/JP/3 22/52s</strong>
                                     </div>
                                     <div class="perLast">
                                       <p>该种质资源为大戟科（Euphobiaceae）橡胶树属，来源巴西亚马逊河，资源种质类型属于野生资源。</p>
                                     </div>
                                  </li>
                                  <li>
                                     <div class="perFirst">
                                         <strong>RO/JP/3 22/52s</strong>
                                     </div>
                                     <div class="perLast">
                                       <p>该种质资源为大戟科（Euphobiaceae）橡胶树属，来源巴西亚马逊河，资源种质类型属于野生资源。</p>
                                     </div>
                                  </li>
                                  <li>
                                     <div class="perFirst">
                                         <strong>RO/JP/3 22/52s</strong>
                                     </div>
                                     <div class="perLast">
                                       <p>该种质资源为大戟科（Euphobiaceae）橡胶树属，来源巴西亚马逊河，资源种质类型属于野生资源。</p>
                                     </div>
                                  </li>
                                </ul>
                                <div class="pageNew">
                                  <el-pagination
                                  background
                                  layout="prev, pager, next"
                                  :total="100">
                                  </el-pagination>
                                  <div class="pageIndex">
                                      <span>跳至</span>
                                      <input type="text" placeholder="1">
                                      <span>页</span>
                                  </div>
                                </div>
                            </div>
                        </div>
                    </div>
                  </div>       
                  <div v-show="cur==1">
                      <div class="title">
                        <p>当前位置：消息中心</p>
                    </div>
                    <div class="personBox">
                        <el-tabs v-model="activeName2">
                            <el-tab-pane label="全部消息(6)" name="first1" :key="'first1'">
                                <ul class="boxUl">
                                  <li>
                                     <div class="divFirst">
                                         <p>系统消息：这是一个消息</p>
                                         <span>2021/01/01    13:21</span>
                                         <a href="##">未读</a>
                                     </div>
                                     <div class="divLast">
                                       <p>这是一段消息内容这是一段消息内容这是一段消息内容这是一段消息内容这是一段消息内容这是一段消息内容这是一段消息内容这是一段消…</p>
                                     </div>
                                     <div class="delete">
                                       <img src="../../assets/img/show/delete.png" alt="">
                                     </div>
                                  </li>
                                  <div class="line"></div>
                                    <li>
                                     <div class="divFirst">
                                         <p>系统消息：这是一个消息</p>
                                         <span>2021/01/01    13:21</span>
                                         <a href="##">未读</a>
                                     </div>
                                     <div class="divLast">
                                       <p>这是一段消息内容这是一段消息内容这是一段消息内容这是一段消息内容这是一段消息内容这是一段消息内容这是一段消息内容这是一段消…</p>
                                     </div>
                                     <div class="delete">
                                       <img src="../../assets/img/show/delete.png" alt="">
                                     </div>
                                  </li>
                                  <div class="line"></div>
                                    <li>
                                     <div class="divFirst">
                                         <p>系统消息：这是一个消息</p>
                                         <span>2021/01/01    13:21</span>
                                         <a href="##">未读</a>
                                     </div>
                                     <div class="divLast">
                                       <p>这是一段消息内容这是一段消息内容这是一段消息内容这是一段消息内容这是一段消息内容这是一段消息内容这是一段消息内容这是一段消…</p>
                                     </div>
                                     <div class="delete">
                                       <img src="../../assets/img/show/delete.png" alt="">
                                     </div>
                                  </li>
                                  <div class="line"></div>
                                    <li class="high">
                                     <div class="divFirst">
                                         <p>系统消息：这是一个消息</p>
                                         <span>2021/01/01    13:21</span>
                                         <a href="##" class="yidu">已读</a>
                                     </div>
                                     <div class="divLast">
                                       <p>这是一段消息内容这是一段消息内容这是一段消息内容这是一段消息内容这是一段消息内容这是一段消息内容这是一段消息内容这是一段消…</p>
                                     </div>
                                     <div class="delete">
                                       <img src="../../assets/img/show/delete.png" alt="">
                                     </div>
                                  </li>
                                  <div class="line"></div>
                                    <li>
                                     <div class="divFirst">
                                         <p>系统消息：这是一个消息</p>
                                         <span>2021/01/01    13:21</span>
                                         <a href="##" class="yidu">已读</a>
                                     </div>
                                     <div class="divLast">
                                       <p>这是一段消息内容这是一段消息内容这是一段消息内容这是一段消息内容这是一段消息内容这是一段消息内容这是一段消息内容这是一段消…</p>
                                     </div>
                                     <div class="delete">
                                       <img src="../../assets/img/show/delete.png" alt="">
                                     </div>
                                  </li>
                                  <div class="line"></div>
                                    <li>
                                     <div class="divFirst">
                                         <p>系统消息：这是一个消息</p>
                                         <span>2021/01/01    13:21</span>
                                        <a href="##" class="yidu">已读</a>
                                     </div>
                                     <div class="divLast">
                                       <p>这是一段消息内容这是一段消息内容这是一段消息内容这是一段消息内容这是一段消息内容这是一段消息内容这是一段消息内容这是一段消…</p>
                                     </div>
                                     <div class="delete">
                                       <img src="../../assets/img/show/delete.png" alt="">
                                     </div>
                                  </li>
                                </ul>
                            </el-tab-pane>
                            <el-tab-pane label="未读消息(2)" name="first2" :key="'first2'">
                                <ul class="boxUl">
                                  <li>
                                     <div class="divFirst">
                                         <p>系统消息：这是一个消息</p>
                                         <span>2021/01/01    13:21</span>
                                         <a href="##">未读</a>
                                     </div>
                                     <div class="divLast">
                                       <p>这是一段消息内容这是一段消息内容这是一段消息内容这是一段消息内容这是一段消息内容这是一段消息内容这是一段消息内容这是一段消…</p>
                                     </div>
                                     <div class="delete">
                                       <img src="../../assets/img/show/delete.png" alt="">
                                     </div>
                                  </li>
                                  <div class="line"></div>
                                    <li>
                                     <div class="divFirst">
                                         <p>系统消息：这是一个消息</p>
                                         <span>2021/01/01    13:21</span>
                                         <a href="##">未读</a>
                                     </div>
                                     <div class="divLast">
                                       <p>这是一段消息内容这是一段消息内容这是一段消息内容这是一段消息内容这是一段消息内容这是一段消息内容这是一段消息内容这是一段消…</p>
                                     </div>
                                     <div class="delete">
                                       <img src="../../assets/img/show/delete.png" alt="">
                                     </div>
                                  </li>
                                  <div class="line"></div>
                                    <li>
                                     <div class="divFirst">
                                         <p>系统消息：这是一个消息</p>
                                         <span>2021/01/01    13:21</span>
                                         <a href="##">未读</a>
                                     </div>
                                     <div class="divLast">
                                       <p>这是一段消息内容这是一段消息内容这是一段消息内容这是一段消息内容这是一段消息内容这是一段消息内容这是一段消息内容这是一段消…</p>
                                     </div>
                                     <div class="delete">
                                       <img src="../../assets/img/show/delete.png" alt="">
                                     </div>
                                  </li>
                                  <div class="line"></div>
                                    <li class="high">
                                     <div class="divFirst">
                                         <p>系统消息：这是一个消息</p>
                                         <span>2021/01/01    13:21</span>
                                         <a href="##" class="yidu">已读</a>
                                     </div>
                                     <div class="divLast">
                                       <p>这是一段消息内容这是一段消息内容这是一段消息内容这是一段消息内容这是一段消息内容这是一段消息内容这是一段消息内容这是一段消…</p>
                                     </div>
                                     <div class="delete">
                                       <img src="../../assets/img/show/delete.png" alt="">
                                     </div>
                                  </li>
                                  <div class="line"></div>
                                    <li>
                                     <div class="divFirst">
                                         <p>系统消息：这是一个消息</p>
                                         <span>2021/01/01    13:21</span>
                                         <a href="##" class="yidu">已读</a>
                                     </div>
                                     <div class="divLast">
                                       <p>这是一段消息内容这是一段消息内容这是一段消息内容这是一段消息内容这是一段消息内容这是一段消息内容这是一段消息内容这是一段消…</p>
                                     </div>
                                     <div class="delete">
                                       <img src="../../assets/img/show/delete.png" alt="">
                                     </div>
                                  </li>
                                  <div class="line"></div>
                                    <li>
                                     <div class="divFirst">
                                         <p>系统消息：这是一个消息</p>
                                         <span>2021/01/01    13:21</span>
                                        <a href="##" class="yidu">已读</a>
                                     </div>
                                     <div class="divLast">
                                       <p>这是一段消息内容这是一段消息内容这是一段消息内容这是一段消息内容这是一段消息内容这是一段消息内容这是一段消息内容这是一段消…</p>
                                     </div>
                                     <div class="delete">
                                       <img src="../../assets/img/show/delete.png" alt="">
                                     </div>
                                  </li>
                                </ul>
                            </el-tab-pane>
                            <el-tab-pane label="已读消息(4)" name="first3" :key="'first3'">
                                <ul class="boxUl">
                                  <li>
                                     <div class="divFirst">
                                         <p>系统消息：这是一个消息</p>
                                         <span>2021/01/01    13:21</span>
                                         <a href="##">未读</a>
                                     </div>
                                     <div class="divLast">
                                       <p>这是一段消息内容这是一段消息内容这是一段消息内容这是一段消息内容这是一段消息内容这是一段消息内容这是一段消息内容这是一段消…</p>
                                     </div>
                                     <div class="delete">
                                       <img src="../../assets/img/show/delete.png" alt="">
                                     </div>
                                  </li>
                                  <div class="line"></div>
                                    <li>
                                     <div class="divFirst">
                                         <p>系统消息：这是一个消息</p>
                                         <span>2021/01/01    13:21</span>
                                         <a href="##">未读</a>
                                     </div>
                                     <div class="divLast">
                                       <p>这是一段消息内容这是一段消息内容这是一段消息内容这是一段消息内容这是一段消息内容这是一段消息内容这是一段消息内容这是一段消…</p>
                                     </div>
                                     <div class="delete">
                                       <img src="../../assets/img/show/delete.png" alt="">
                                     </div>
                                  </li>
                                  <div class="line"></div>
                                    <li>
                                     <div class="divFirst">
                                         <p>系统消息：这是一个消息</p>
                                         <span>2021/01/01    13:21</span>
                                         <a href="##">未读</a>
                                     </div>
                                     <div class="divLast">
                                       <p>这是一段消息内容这是一段消息内容这是一段消息内容这是一段消息内容这是一段消息内容这是一段消息内容这是一段消息内容这是一段消…</p>
                                     </div>
                                     <div class="delete">
                                       <img src="../../assets/img/show/delete.png" alt="">
                                     </div>
                                  </li>
                                  <div class="line"></div>
                                    <li class="high">
                                     <div class="divFirst">
                                         <p>系统消息：这是一个消息</p>
                                         <span>2021/01/01    13:21</span>
                                         <a href="##" class="yidu">已读</a>
                                     </div>
                                     <div class="divLast">
                                       <p>这是一段消息内容这是一段消息内容这是一段消息内容这是一段消息内容这是一段消息内容这是一段消息内容这是一段消息内容这是一段消…</p>
                                     </div>
                                     <div class="delete">
                                       <img src="../../assets/img/show/delete.png" alt="">
                                     </div>
                                  </li>
                                  <div class="line"></div>
                                    <li>
                                     <div class="divFirst">
                                         <p>系统消息：这是一个消息</p>
                                         <span>2021/01/01    13:21</span>
                                         <a href="##" class="yidu">已读</a>
                                     </div>
                                     <div class="divLast">
                                       <p>这是一段消息内容这是一段消息内容这是一段消息内容这是一段消息内容这是一段消息内容这是一段消息内容这是一段消息内容这是一段消…</p>
                                     </div>
                                     <div class="delete">
                                       <img src="../../assets/img/show/delete.png" alt="">
                                     </div>
                                  </li>
                                  <div class="line"></div>
                                    <li>
                                     <div class="divFirst">
                                         <p>系统消息：这是一个消息</p>
                                         <span>2021/01/01    13:21</span>
                                        <a href="##" class="yidu">已读</a>
                                     </div>
                                     <div class="divLast">
                                       <p>这是一段消息内容这是一段消息内容这是一段消息内容这是一段消息内容这是一段消息内容这是一段消息内容这是一段消息内容这是一段消…</p>
                                     </div>
                                     <div class="delete">
                                       <img src="../../assets/img/show/delete.png" alt="">
                                     </div>
                                  </li>
                                </ul>
                            </el-tab-pane>
                      </el-tabs>
                    </div>
                  </div>
                  <div v-show="cur==2">
                    <div class="title">
                        <p>当前位置：个人中心 > 个人设置</p>
                    </div>
                    <div class="content1">
                        <div class="contentLeft">
                            <dl>
                              <dt>
                                <img src="../../assets/img/show/person.png" alt="">
                              </dt>
                              <dd>
                                <p>昵称：<span>abcd</span></p>
                                <p>姓名：<span>张三</span><a>未认证</a>        
                                <p>联系方式：<span>11111111111</span></p>
                                <p>所在地区：<span>海南-海口</span></p>
                                <p>单位名称：<span>兴隆热带植物园</span></p>
                                 <a href="##">编辑</a>
                                </dd>
                            </dl>
                            <div class="ewm">
                              <img src="../../assets/img/show/ewm.png" alt="">
                            </div>
                        </div>
                         <div class="contentRig fr">
                            <dl>
                              <dt>
                                <img src="../../assets/img/show/person.png" alt="">
                              </dt>
                              <dd>
                                <p>修改头像</p>
                              </dd>
                            </dl>
                            <h1>基本信息</h1>
                           <el-form ref="form"   :label-position="labelPosition" :model="form" label-width="100px">
                              <el-form-item label="昵称：">
                                <el-input v-model="form.nichen" placeholder="abcd"></el-input>
                                <span>修改</span>
                              </el-form-item>
                              <el-form-item label="姓名：">
                                <el-input v-model="form.name" placeholder="张三"></el-input>
                                 <span>修改</span>
                              </el-form-item>
                               <el-form-item label="联系方式：">
                                <el-input v-model="form.tel" placeholder="111111111111"></el-input>
                                 <span>修改</span>
                              </el-form-item>
                              <el-form-item label="所在地区：">
                                <el-select v-model="form.region" placeholder="海南-海口">
                                  <el-option label="区域一" value="shanghai"></el-option>
                                  <el-option label="区域二" value="beijing"></el-option>
                                </el-select>
                              </el-form-item>
                              <el-form-item label="单位名称：">
                                <el-input v-model="form.dwmc" placeholder="兴隆热带植物园"></el-input>
                                 <span>修改</span>
                              </el-form-item>
                              <el-form-item label="所属角色：">
                                <el-input v-model="form.juese" placeholder="种质资源所有方"></el-input>
                              </el-form-item>
                              <el-form-item label="实名认证：">
                                 <a>实名认证</a>
                              </el-form-item>
                              <el-form-item class="saveBtn">
                                <el-button type="primary">保存</el-button>
                              </el-form-item>
                           </el-form>
                        </div>
                    </div>
                  </div>
                </div>
            </div>
          </div>
           
    <footer>
         <p>主持单位:中国热带农业科学院热带作物品种资源研究所 | 版权所有©热带作物种质资源信息网</p>
    </footer>
      </div>
  </div>
</template>
<script>
export default {
  name: "zzpList",
  data() {
    return {
        cur:0, //默认选中第一个tab
     input: '',
     //默认第一个选项卡
            activeName: "first",
            activeName2:'first1',
            labelPosition: 'left',
            form: {
          name: '',
          region: '',
          tel:'',
          dwmc:'',
          juese:'',
        }
    };
  },
  methods: {
  

  },
};
</script>
<style scoped>
@import "../../assets/scss/show.css";
  .bodyWrap{
    width:100%;
    margin:0 auto;
    background: #eeeeee;
  }
  .delete{
    display: none !important;
  }
  .high .delete{
    display: block !important;
  }
 .boxUl li:hover .delete{
    display: block !important;
  }
   .boxUl li:hover{
    background: #e5f3ed;
    border-bottom: 1px solid #e5f3ed;
  }
  .navBox{
 height: 42px;
 line-height: 42px;
 background: #02874a;
 width: 100%;

  }
  .tabContent>div:last-child{
        height: 805px;
  }
  .tabContent>div:first-child{
    height: 1220px;
  }
  .tabContent{
    width: 1200px;
    margin: 0 auto;
  }
  .navBox ul{
    width: 1200px;
    margin: 0 auto;
    padding-left: 15px;
  }
  .active2{
    background: #00532d;
  }
 .navBox li{     
    width: 115px !important;
    color: #fff;font-size: 16px !important;
    text-align: center;
    cursor: pointer;
    display: inline-block;
  }
.pageNew{
    margin:8px auto 0 auto;
    text-align: center;
    padding-bottom: 30px;
  }
  .pageIndex{
    display: inline-block;
    padding: 2px 0;vertical-align: bottom;
  }
  .pageIndex span{
     font-size: 13px;
     color: #606266;
  }
  
  .pageIndex input{
    width: 40px;
    border: 1px solid #dddee1;
    text-align: center;
    font-size: 13px;
    height: 26px;
    line-height: 26px;
    border-radius:3px;
  }
  .rigBox2>h2{
    font-size: 15px;
    color: #333333;
    font-weight: normal;
    margin: 23px 0 10px 0;
  }
   .rigBox2>h2 span{
 color: #02874a;
  }
  .myZy{
    border-radius: 5px;
    background: #fff;margin-top: 26px;
  }
  .perUl li:nth-child(odd){
    background: #e5f3ed;
  }
  .myZy span{
    width: 5px;
    height: 26px;
    background:#fff;
    display: inline-block;
    margin-top: 13.5px;
    float: left;
    margin-right:25px;
  }
  .myZy li{
    font-size: 16px;
    color: #333333;
    border-bottom: 1px solid #02874a;
    height: 53px;
    line-height: 53px;
  }
  .myZy li:last-child{
    border-bottom: 0;
  }
  .myZyHigh{
    background: #02874a;
    color: #fff !important;
  }
  .yidu{
    color: #02874a !important;
  }
  .high{
    background:#e5f3ed;
    border-bottom: 1px solid #e5f3ed;
  }
  .delete{
      display: inline-block;
    margin-right: 27px;
    text-align: right;
    float: right;
  }
  .delete img{
    width: 23px;
    display: block;
  }
  .boxUl li{
    padding: 34px 18px;
  
  }
  .perUl li{
    padding: 20px 18px 28px 18px;
  
  }
  .line{
  border-bottom: 1px solid #80c3a4;
  margin: 0 18px;
  border-left: 1px solid #c8dcdb;
  }
  .divFirst p{
    font-size: 15px;
    display: inline-block;
    color: #333333;
  }
  .divFirst span{
font-size: 13px;
margin: 0 37px;
    color: #999999;
  }
  .divFirst a{
 font-size: 15px;
    color: #e30000;
  }
  .divLast{
    margin-top: 13px;
    display: inline-block;
  }
   .perFirst strong{
    font-size: 15px;
    display: inline-block;
    color: #333333;
  }
  .perLast p{
    font-size: 15px;
    color: #666666;
    margin-top: 10px;
  }
  .divLast p{
    font-size: 15px;
    color: #666666;
  }
  .personBox{
    background-color: #fff;
     border: 1px solid #dfe6eb;
    border-radius:5px;
    padding:7px 0;
  }
  .saveBtn{
        padding: 70px 0;
    text-align: center;
  }
  .searchBtn{
        display: inline-block;
    float: right;
    background: #02874a;
    height:50px !important;
    width: 120px;
    border-radius: 5px;
    text-align: center;
    
  }
  .searchBtn button{
        background: none;
    height: 50px !important;
    line-height: 50px !important;
    border: none;
    color: #fff;
    font-size: 15px;
  }
  .contentLeft dl{
    padding-top: 25px;
    width:260px;
    background:#fff;
    border: 1px solid #dfe6eb;
    border-radius: 5px;
    padding-bottom: 15px;
  } 
  .contentRig h1{
    font-size: 16px;;
  color: #484848;
margin: 30px auto 10px auto;

  }
  .el-form-item  span{
    font-size: 15px;
    color: #d67825;
    cursor: pointer;
  }
  .el-form-item a{
    color: #02874a;
    font-size: 15px;
  }
  .contentLeft dl dt img{
      width:140px;
      display: block;
      margin: 0 auto;
  }
  .ewm{
    margin-top: 26px;
  }
  .ewm img{
    display: block;
    margin:0 auto;
    width: 197px;
  }
   .contentLeft dl dd{
      margin-top: 15px;
      padding:0 18px;
  }

   .content1 dl dd>a{
     font-size: 15px;
     color: #108f55;
     background: url(../../assets/img/show/bianji.png) no-repeat left center;
     padding-left:20px;
     background-size: 15px 15px;
     margin-left: 160px;
  }
  .content1 dl dd p{
     font-size: 15px;
     color: #999999;
     margin-bottom: 10px;
  }
   .content1 dl dd p a{
   font-size: 15px;
     color: #108f55;
     margin-left: 30px;
  }
   .content1 dl dd p span{
   color: #333333;
  }
  .contentLeft{
    width:260px;
    display: inline-block;
  }
  .contentRig{
    width:870px;
     border: 1px solid #dfe6eb;
    background:#fff;
    border-radius: 5px;
    padding:0 20px;
  }
  .rigBox{
     width:910px;
  }
    .rigBox2{
     border: 1px solid #dfe6eb;
    background:#fff;
    border-radius: 5px;
    padding:0 20px;
  }
  .contentRig dl dt img{
      width:140px;
      display: block;
      margin:50px auto 20px auto;
  }
   .contentRig dl dd p{
    color:#484848;
    font-size: 15px;
    text-align: center;
  }
  .title{
    padding:17px 0;
  }
  .title p{
    font-size: 12px;
    color: #666666;
  }
  footer{
    height: 84px;
    line-height: 84px;
    background: #4a4e53;
    margin-top: 50px;
    text-align: center;
  }
  footer p{
    font-size: 14px;
    color: #fff;
  }
.el-tabs__item{
    font-size: 20px;
    color:#02874a;
  }
  .bottomBox{
    width: 1200px;
     margin: 0 auto;
  }
  .headBottom{
    background:#fff;
    height: 100px;
     
  }
  .headSearch{
    height: 40px;
    margin-top: 30px;
    position: relative;
  }
  .rigBox1{
    height: 50px;
    margin-bottom: 10px;
  }
  .headSearch span{
        background: #02874a;
    position: absolute;
    right: -45px;
    top: 0;
    height: 38px;
    width: 51px;
    border: 1px solid #02874a;
    border-top-right-radius: 5px;
    border-left: 0;
    border-bottom-right-radius: 5px;
  }
  .headSearch span img{
    margin: 0 auto;
    text-align: center;
    display: block;
    margin-top: 7px;
    height: 24px;
  }
  .botLeft img{
   width: 489px;
   height: 42px;
   display: block;
   margin-top:29px;
  }
  .headUl li{
    font-size: 16px;
    color: #333333;
    display: inline-block;
    float: left;
    margin-right: 40px;
    line-height: 100px;
  }
  .topBox{
      width: 1200px;
       margin: 0 auto;
  }
  .headTop{
    background:#f1f1f1;
    height: 30px;
    line-height: 28px;
  }
  .el-input__inner{
    border: 1px solid #02874a !important;
    font-size: 14px;
  }
  .headLeft span{
    font-size: 12px;
    color: #666666;
    display: inline-block;
    margin-right: 30px;
  }
  .headRig span{
    font-size: 12px;
    color: #666666;
    margin-left: 30px;
     display: inline-block;
  }
</style>
